import { Row, Col, Card, Form, InputGroup } from 'react-bootstrap';
import { FaFileInvoice, FaMoneyBill, FaPercent, FaCreditCard, FaTag, FaToggleOn, FaToggleOff } from 'react-icons/fa';

const BillCalculationCard = ({ 
  formData, 
  originalValues, 
  formatCurrency, 
  onInputChange 
}) => {
  
  const calculateMaxReceivedPayment = () => {
    const totalAmount = parseFloat(formData.billDetails.totalAmount) || 0;
    const advancePaid = parseFloat(formData.billDetails.advancePaid) || 0;
    const receivedPayment = parseFloat(formData.billDetails.receivedPayment) || 0;
    
    
    return Math.max(0, totalAmount - (advancePaid - receivedPayment));
  };

  const maxReceivedPayment = calculateMaxReceivedPayment();

  
  const calculateSubtotal = () => {
    return (parseFloat(formData.billDetails.foodBill) || 0) +
           (parseFloat(formData.billDetails.djMusic) || 0) +
           (parseFloat(formData.billDetails.serviceCharges) || 0) +
           (parseFloat(formData.billDetails.hallRent) || 0) +
           (parseFloat(formData.billDetails.bwdStage) || 0) +
           (parseFloat(formData.billDetails.acCharges) || 0) +
           (parseFloat(formData.billDetails.heaterCharges) || 0) +
           (parseFloat(formData.billDetails.ladiesWaiter) || 0) +
           (parseFloat(formData.billDetails.otherCharges) || 0);
  };

  const subtotal = calculateSubtotal();
  const totalAmount = parseFloat(formData.billDetails.totalAmount) || 0;
  const advancePaid = parseFloat(formData.billDetails.advancePaid) || 0;
  const remainingAmount = parseFloat(formData.billDetails.remainingAmount) || 0;
  const govtTax = parseFloat(formData.billDetails.govtTax) || 0;
  const discount = parseFloat(formData.billDetails.discount) || 0;
  const includeTax = formData.billDetails.includeTax || false;

  const amountBeforeRemaining = includeTax 
    ? (subtotal + govtTax - discount) 
    : (subtotal - discount);
  
  const finalAmount = amountBeforeRemaining - remainingAmount;

  return (
    <Card className="border-0 shadow-sm mb-4">
      <Card.Header className="bg-white border-0 py-3">
        <h5 className="mb-0 fw-bold">
          <FaFileInvoice className="me-2" />
          Bill Calculation
        </h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Food Bill</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.foodBill"
                  value={formData.billDetails.foodBill}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                  readOnly
                  className="bg-light"
                />
              </InputGroup>
              
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>DJ Music</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.djMusic"
                  value={formData.billDetails.djMusic}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Service Charges (Rs)</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.serviceCharges"
                  value={formData.billDetails.serviceCharges}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
              
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Hall Rent</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.hallRent"
                  value={formData.billDetails.hallRent}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>BWD Stage</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.bwdStage"
                  value={formData.billDetails.bwdStage}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>AC Charges</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.acCharges"
                  value={formData.billDetails.acCharges}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Heater Charges</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.heaterCharges"
                  value={formData.billDetails.heaterCharges}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Ladies Waiter</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.ladiesWaiter"
                  value={formData.billDetails.ladiesWaiter}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Other Charges</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaMoneyBill /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.otherCharges"
                  value={formData.billDetails.otherCharges}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Government Tax</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaPercent /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.govtTax"
                  value={formData.billDetails.govtTax}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                  className={!includeTax ? "bg-light" : ""}
                  readOnly={!includeTax}
                />
              </InputGroup>
              <div className="d-flex align-items-center mt-1">
                <Form.Check
                  type="switch"
                  id="include-tax-switch"
                  name="billDetails.includeTax"
                  checked={includeTax}
                  onChange={onInputChange}
                  className="me-2"
                />
                <Form.Text className={includeTax ? "text-success" : "text-muted"}>
                  {includeTax ? (
                    <>Tax included in calculation <FaToggleOn className="ms-1" /></>
                  ) : (
                    <>Tax excluded from calculation <FaToggleOff className="ms-1" /></>
                  )}
                </Form.Text>
              </div>
             
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Discount (Rs)</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaTag /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.discount"
                  value={formData.billDetails.discount}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                />
              </InputGroup>
              
            </Form.Group>
          </Col>
          
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Total Received Amount</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaCreditCard /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.advancePaid"
                  value={formData.billDetails.advancePaid}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                  readOnly
                  className="bg-light"
                />
              </InputGroup>
              
            </Form.Group>
          </Col>

          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>New Received Payment</Form.Label>
              <InputGroup>
                <InputGroup.Text><FaCreditCard /></InputGroup.Text>
                <Form.Control
                  type="number"
                  name="billDetails.receivedPayment"
                  value={formData.billDetails.receivedPayment}
                  onChange={onInputChange}
                  placeholder="0"
                  min="0"
                  max={maxReceivedPayment}
                  step="1"
                />
              </InputGroup>
              
            </Form.Group>
          </Col>

          <Col md={12} className="mb-3">
            <Card className="border-primary">
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <h6 className="text-muted mb-1">Subtotal</h6>
                    <h5 className="fw-bold">
                      {formatCurrency(subtotal)}
                    </h5>
                  </Col>
                  <Col md={6}>
                    <h6 className="text-muted mb-1">
                      {includeTax ? 'After Tax' : 'Subtotal (Tax Excluded)'}
                    </h6>
                    <h5 className="fw-bold">
                      {formatCurrency(includeTax ? subtotal + govtTax : subtotal)}
                      {!includeTax && govtTax > 0 && (
                        <small className="text-muted ms-2">
                          (Tax: {formatCurrency(govtTax)} extra)
                        </small>
                      )}
                    </h5>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={6}>
                    <h6 className="text-muted mb-1">After Discount</h6>
                    <h5 className="fw-bold text-primary">
                      {formatCurrency(amountBeforeRemaining)}
                    </h5>
                  </Col>
                  <Col md={6}>
                    <h6 className="text-muted mb-1">Remaining Amount</h6>
                    <h5 className="fw-bold" style={{ color: '#dc3545' }}>
                      - {formatCurrency(remainingAmount)}
                    </h5>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md={12}>
                    <h4 className="text-muted mb-1">Net Payable</h4>
                    <h2 className="fw-bold text-success">
                      {formatCurrency(finalAmount)}
                    </h2>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={12}>
                    <small className="text-muted">
                      {includeTax ? (
                        <>Subtotal: {formatCurrency(subtotal)} + Tax: {formatCurrency(govtTax)} - Discount: {formatCurrency(discount)} = {formatCurrency(amountBeforeRemaining)} - Remaining: {formatCurrency(remainingAmount)} = {formatCurrency(finalAmount)}</>
                      ) : (
                        <>Subtotal: {formatCurrency(subtotal)} - Discount: {formatCurrency(discount)} = {formatCurrency(amountBeforeRemaining)} - Remaining: {formatCurrency(remainingAmount)} = {formatCurrency(finalAmount)}</>
                      )}
                    </small>
                  </Col>
                </Row>
                {!includeTax && govtTax > 0 && (
                  <Row className="mt-2">
                    <Col md={12}>
                      <small className="text-warning">
                        <strong>Note:</strong> Tax of {formatCurrency(govtTax)} is excluded and will be added separately.
                      </small>
                    </Col>
                  </Row>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default BillCalculationCard;